import React from 'react';
import {
  PRODUCT_VENDOR_TERMS_MARKER,
  PRODUCT_VENDOR_TERMS_TAIL,
} from '../lib/productDescription';

/**
 * Стандартный блок про РРЦ и услуги Антологии в конце описания решения.
 */
const ProductVendorTermsNotice = ({ className = 'mb-8' }) => (
  <div
    className={`rounded-xl bg-[#F0F0F0] px-5 py-4 text-sm leading-relaxed text-foreground/90 ${className}`}
    data-testid="product-vendor-terms-notice"
  >
    <p className="mb-2">{PRODUCT_VENDOR_TERMS_MARKER}</p>
    <p>{PRODUCT_VENDOR_TERMS_TAIL}</p>
  </div>
);

export default ProductVendorTermsNotice;
